import './App.css';
import AppRouter from './router/AppRouter';

import 'bootstrap/dist/css/bootstrap.min.css';

import "./styles/reuse/block.css";
import "./styles/reuse/buttons.css";
import "./styles/personal/main_page.css";
import "./styles/personal/map_workspace.css";
import "./styles/personal/comparison_maps.css";
import "./styles/personal/statistics_report.css";
import 'leaflet/dist/leaflet.css';


function App() {
  return (
    <>
    <AppRouter/>
    </>
  );
}

export default App;
